import React from "react";
import axios from "axios";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBCard,
  MDBCardBody
} from "mdbreact";
import "../auth.css";
import "../list.css";
import { Link } from "react-router-dom";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import { Grid, Segment, Button, Checkbox } from "semantic-ui-react";
import Select from "react-select";
import { reactLocalStorage } from "reactjs-localstorage";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { API_BASE_URL } from "../utils/endpoints";

var subadminOptions = [];
var balance_type = [];
class Balance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: [
        { label: "Bulk SMS", value: "bulk_sms" },
        { label: "Bulk SMS Promotion", value: "bulk_sms_promotion" },
        { label: "Profiled SMS", value: "profiled" },
        { label: "LBA SMS", value: "lba" },
        { label: "Survey SMS", value: "survey" },
        { label: "International SMS", value: "international" }
      ],

      typeselect: "",
      nameoftype: "",
      balance: 0,
      expiry_data: "",
      code: "",
      enable: false,
      options_sender: [],
      subadminselect: [],
      user_id: "",
      isArabic: false,
      superOperator:false
    };
  }

  componentDidMount() {
    if(reactLocalStorage.get("role") === "ROLE_OPERATOR_INT")
    {
      this.setState({ superOperator: true });
    }
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      } else {
        const data = res.data.result.balances;
        var array = [];
        if (data !== undefined) {
          Object.keys(data).map(function(key) {
            array.push({
              label: key.replace(/_/g, " "),
              value: key
            });
            balance_type = array;
          });
        }
        if (reactLocalStorage.get("role") === "ROLE_OPERATOR" || reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
          balance_type = [
            { label: "bulk sms", value: "bulk_sms" },
            { label: "bulk sms promotion", value: "bulk_sms_promotion" }
          ];
        }
      }
      this.setState({ code: "" });
    });
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/findallusers";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/findallusers";
    }

     headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data !== undefined) {
        const dataoption = res.data;
        var length = res.data.length;
        var i;
        const newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option =
            dataoption[i].firstName + " (" + dataoption[i].userName + ")";

          newArr.push({
            label: value_option,
            value: dataoption[i].id
          });
        }
        subadminOptions = newArr;
        this.setState({ code: "" });
      }
    });
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".redd_color").style =
        "text-align:right;width: 20%;margin-right: 14%;white-space: pre;";
      document.querySelector(".Logo_auth").style = "float: left !important";
      document.querySelector(".form_add_form").style = "text-align: right;";
    } else {
      document.querySelector(".Logo_auth").style = "float: right !important";
    }
  }
  onChange = values => {
    this.setState({ typeselect: values.value });
  };

  handleChangebalance = event => {
    this.setState({ balance: event.target.value });
  };

  handleChangebillingcode = event => {
    this.setState({ code: event.target.value });
  };
  enable = event => {
    if (this.state.enable === false) {
      this.setState({ enable: true });
    } else {
      this.setState({ enable: false });
    }
  };
  onChangesubadmin = event => {
    this.setState({ subadminselect: event.label }, function() {});
    this.setState({ user_id: event.value }, function() {});
  };
  handleSubmit = event => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");
    const data = {
      balance_type: this.state.typeselect,
      balance_count: JSON.parse(this.state.balance),
      expiry: this.state.expiry_data,
      billing_code: this.state.code,
      enable: true,
      user_id: this.state.user_id
    };
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/addBalance";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/addBalance";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
       
        if (response.data.status === 'success') {
          window.location = "AddBalance";
        } 
        if(response.data.status === 'no sufficient balance')
        {
          toast({
            type: "warning",
            title: i18n.t("warning.label"),
            description: response.data.status,
            animation: "bounce",
            time: 5000
          });
        }
        else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
        } 
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
      });
  };
  render() {
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <Grid columns={2} divided>
            <Grid.Row stretched className="fixed_header">
              <Grid.Column className="grid_logo">
                <Segment>
                  <h3 className="text_style ">
                    {i18n.t("add_balance.label")}
                  </h3>
                </Segment>
              </Grid.Column>

              <Grid.Column className="grid_language" style={{ width: "32%" }}>
                <Segment>
                  <Link to="/app/addbalance">
                    <img
                      src={require("../pictures/report.png")}
                      className="Logo_auth"
                      alt="logo"
                    />
                  </Link>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <hr />

          <div className="add_form">
            <MDBContainer>
              <MDBRow>
                <MDBCol md="6">
                  <MDBCard className="add_card">
                    <MDBCardBody>
                      <form
                        onSubmit={this.handleSubmit}
                        className="form_add_form"
                      >
                        <p className="h4 text-center py-4 text_style ">
                          {" "}
                          {i18n.t("add_balance.label")}
                        </p>
                        <p className="h6 black_color">{i18n.t("type.label")}</p>
                        <Select
                          placeholder={i18n.t("select.label")}
                          fluid
                          search
                          selection
                          options={balance_type}
                          onChange={this.onChange.bind(this)}
                        />
                        <br />
                        {this.state.superOperator === true ? (
                             <p className="h6 black_color">
                             {i18n.t("choose_admin.label")}
                           </p>
                          ) : (
                            <p className="h6 black_color">
                            {i18n.t("choose_sub_admin.label")}
                          </p>
                          )}
                      
                        <Select
                          placeholder={i18n.t("select.label")}
                          fluid
                          search
                          selection
                          options={subadminOptions}
                          onChange={this.onChangesubadmin.bind(this)}
                        />
                        <br />

                        <label
                          htmlFor="defaultFormCardNameEx"
                          className="grey-text font-weight-light"
                        >
                          {i18n.t("balance.label")}
                        </label>
                        <input
                          type="number"
                          id="defaultFormCardNameEx"
                          className="form-control"
                          name="balance"
                          onChange={this.handleChangebalance}
                        />

                        <br />
                        <label
                          htmlFor="defaultFormCardNameEx"
                          className="grey-text font-weight-light"
                          style={{display:'none'}}
                        >
                          {i18n.t("billing_code.label")}
                        </label>
                        <input
                          type="text"
                          id="defaultFormCardNameEx"
                          className="form-control"
                          name="billing_code"
                          onChange={this.handleChangebillingcode}
                          style={{display:'none'}}
                        />
                        <br />

                        <Checkbox
                          label={i18n.t("enable.label")}
                          style={{ width: "34%" ,display:'none'}}
                          onClick={this.enable}
                          id="1"
                        />

                        <div className="text-center py-4 mt-3">
                          <Link to="/app/addbalance">
                            <Button className="submit_btn_red">
                              <MDBBtn color="cyan">
                                {i18n.t("Back.label")}
                              </MDBBtn>
                            </Button>
                          </Link>
                          <Button className="submit_btn_red">
                            <MDBBtn color="cyan" type="submit">
                              {i18n.t("Submit.label")}
                            </MDBBtn>
                          </Button>
                        </div>
                      </form>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </div>
          <SemanticToastContainer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { ...state };
};
export default connect(mapStateToProps)(Balance);
